import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { MessageErrorInterceptor } from './interceptors/message-error.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { PreloaderComponent } from './components/preloader/preloader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material';
import { NgHttpLoaderModule } from 'ng-http-loader';


import localES from "@angular/common/locales/es";
import localESPE from "@angular/common/locales/es-PE";
import { CommonModule, DatePipe, registerLocaleData } from "@angular/common";

/*Configuración del país para las fechas  */
import { EnvironmentServiceFactory, EnvironmentServiceProvider } from './core/providers/environment.provider';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { AgmCoreModule } from '@agm/core';
import { StatusTablePipe } from './pipes/status-table.pipe';
/*Captcha v3*/

import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
//

registerLocaleData(localES);
registerLocaleData(localESPE);

const apiKeyGoogleMap = EnvironmentServiceFactory().apiKeyGoogleMap;
const apikeyV3GoogleMap=EnvironmentServiceFactory().captchaKeyV3;

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent

  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    RecaptchaV3Module,
    NgHttpLoaderModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: apiKeyGoogleMap,
      libraries: ['places']
    })
  ],
  providers: [
    StatusTablePipe,
    DatePipe,
    {
      provide:RECAPTCHA_V3_SITE_KEY,
      useValue:apikeyV3GoogleMap
    },
    // { provide: LOCALE_ID, useValue: 'es-ES' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MessageErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    EnvironmentServiceProvider,
    {
      provide: LOCALE_ID,
      useValue: 'ES-PE'
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [PreloaderComponent]
})
export class AppModule {


  constructor() {

    const IS_IFRAME = window !== window.parent;
    if (IS_IFRAME) {

      if (localStorage.getItem("myrequest")
        || localStorage.getItem("rec"))
        localStorage.clear();
    } else {
      if (localStorage.getItem("myrequest")
        || localStorage.getItem("rec"))
        localStorage.clear();
    }
  }
}
